/*global translate*/
import React, {useState} from 'react'
import translate from '../../../../classes/lang'
const RxAccountInfo = global.rootRequire('components/shares/rxAccountInfo').default

const OnOffUser = global.rootRequire('components/shares/rxOnOffUser').default
const OnOffGroup = global.rootRequire('components/shares/rxOnOffGroup').default

const { rxaget, rxChangeSlug, subString ,changeColorSVG, isElectron } = global.rootRequire('classes/ulti')
const { changeColorAva, textAva} = global.rootRequire('classes/chat')

const worker = global.rootRequire('classes/globalUser')
const CallRatingComponent = global.rootRequire('components/shares/call_rating/rxCallRating').default
let zget = global.rxu.get
global.isclient && require('./index.css')



// function UserName({ uid, userid }) {
//   return (users && users[uid] && users[uid]['name_display']) ? users[uid]['name_display'] : translate('Stranger')
// }

// const MemoizedUserName = UserName//React.memo(UserName);


export const renderBody = (vm) => {
  let userStatus = vm.getUserStatus_txt(zget(vm.state.group, 'userStatus', {}))
  return (
    <div>
      {zget(vm.state.group, 'type', '') !== '' && <div className='ztbar'>
        <div className='ztbar_avatar_header'> 
          {(zget(vm.state.group, 'type', 0) === 3) && <React.Fragment>
            { zget(vm.state.partnerUSer, 'profile_url', '') && <img src={global.rxu.config.get_static + zget(vm.state.partnerUSer, 'profile_url', '')} alt='profile_url' className='ava-group_header images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }
            { !zget(vm.state.partnerUSer, 'profile_url', '') && <span className='ava-span_header' style={{ background: `${changeColorAva(rxaget(vm.state.group, 'partner_id', rxaget(vm.state.group, 'group_id', '')))}` }}>
                {textAva(rxChangeSlug(zget(vm.state.partnerUSer, 'full_name', ''))) || textAva(zget(vm.state.group, 'group_fullname', '')) }
              </span> 
            }
          </React.Fragment>}
          {(zget(vm.state.group, 'type', 0) !== 3) && <React.Fragment>
            { zget(vm.state.group, 'avatar_url', '') &&  <img src={global.rxu.config.get_static + zget(vm.state.group, 'avatar_url', '')} alt='avatar_url' className='ava-group_header images-static' onError={(e) => {e.target.onerror = null; e.target.src = './images/default/static/avadefault.svg' }} /> }
            { !zget(vm.state.group, 'avatar_url', '') && <span className='ava-span_header' style={{ background: `${changeColorAva(rxaget(vm.state.group, 'group_id', ''))}` }}>
                {textAva(rxChangeSlug(zget(vm.state.group, 'name', ''))) || textAva(zget(vm.state.group, 'group_fullname', '')) }
              </span> 
            }  
          </React.Fragment>}    
        
        </div>
        <div className='ztbar_left'>
          <div className='ztbar_name'>{subString((zget(vm.state.group, 'name', '') || zget(vm.state.group, 'group_fullname', '')) , 50) }</div>
          <div className='ztbar_status'>
            

            {/*<span className='ztab-more-user_status'>{translate('Offline')}</span>*/}

            {/*{(zget(vm.state.group, 'type', 0) === 3) &&  vm.state.group && 
              (vm.state.group.partner_id || vm.state.group.occupants_uins[0]) && 
              vm.state.usersStatus[Number(vm.state.group.partner_id  || vm.state.group.occupants_uins[0])] &&
              (vm.state.usersStatus[Number(vm.state.group.partner_id  || vm.state.group.occupants_uins[0])].online_status === 1
                ? <span className='ztab-more-user_status'>{translate('Online')}</span> :
                vm.state.usersStatus[Number(vm.state.group.partner_id  || vm.state.group.occupants_uins[0])].last_seen_at > 0 ?
                  <span className='ztab-more-user_status'>
                    {translate('Last seen ')}
                    {autoConvertTime(vm.state.usersStatus[Number(vm.state.group.partner_id  || vm.state.group.occupants_uins[0])].last_seen_at)}
                  </span> : <span className='ztab-more-user_status'>{translate('Offline')}</span>)}*/}

            {(zget(vm.state.group, 'type', 0) === 3) && <span className='ztab-more-user_status'>
              {userStatus.length === 0 && <OnOffUser userId={rxaget(vm.state.group, 'partner_id', '')} />}
              {userStatus.length > 0 && userStatus}
            </span>}

            {(zget(vm.state.group, 'type', 0) !== 3) && <span className='ztab-more-user_status'>
              {vm.uniqArray(zget(vm.state.group, 'occupants_uins', [])).length} {
              translate(' member')} <OnOffGroup groupId={rxaget(vm.state.group, 'group_id', '')} arrUsers={rxaget(vm.state.group, 'occupants_uins', '')} /> </span>}

          </div>
        </div>
        <div className='ztbar_right'>

          {(zget(vm.state.group, 'isDraft', 0) != true && zget(vm.state.group, 'type', 0) === 3 && !vm.state.isBlocked) && <div className='ztbar_btn ztbar_btncall filter_img_class' onClick={(e) => vm.onClickStartCall('voicecall')}><img src={changeColorSVG('./images/default/icons/callright.svg')} alt='' className='icon-phone icon32' /></div>}
          {(zget(vm.state.group, 'isDraft', 0) != true && zget(vm.state.group, 'type', 0) === 3 && !vm.state.isBlocked) && <div className='ztbar_btn ztbar_btnsearch filter_img_class' onClick={(e) => vm.onClickStartCall('videocall')}><img src={changeColorSVG('./images/default/icons/videocall.svg')} alt='' className='icon-magnifier_icon32' /></div>}

          {/* {(vm.state.isShowBtnGroupCall && zget(vm.state.group, 'type', 0) === 2 && zget(vm.state.group, 'occupants_uins', []).length <= 50 && !vm.state.isBlocked) && <div className='ztbar_btn ztbar_btnsearch filter_img_class' onClick={(e) => vm.onClickStartGroupCall('groupcall')}><img src={changeColorSVG('./images/default/icons/videocall.svg')} alt='' className='icon-magnifier_icon32' /></div>} */}
          
          {/*{(zget(vm.state.group, 'group_id', '') !== '' && !vm.state.isBlocked) && <div className='ztbar_btn ztbar_btnsearch filter_img_class' onClick={(e) => vm.props.rxnavToggle("searchGroup", {})}><img src={changeColorSVG('./images/default/icons/search-active.svg')} alt='' className='icon32' /></div>}*/}

          <div className={!(vm.state.tabmore === true || vm.state.tabmore.data === true) ? 'ztbar_btn ztbar_btnmore' : 'ztbar_btn  ztbar_btnmore ztbar_btn-active'} onClick={e => vm.onClickTabMore()}><img src={changeColorSVG('./images/default/icons/menumore.svg')} alt='' className='icon-options icon32' /></div>
        </div>
      </div>}
      { (vm.state.tabmore === true || vm.state.tabmore.data === true) ? <RxAccountInfo userStatus={userStatus} /> : null}
      {/* {!vm.state.isShowBtnGroupCall && <div className='ztbar-groupcall'>
        <div className='ztbar_left-groupcall'>
          <div className='ztbar_name-groupcall'>{translate('Group Call')}</div>
          <div className='ztbar_desc-groupcall'>{translate('Ongoing Group Call')}</div>
        </div>
        <div className='ztbar_right-groupcall' onClick={(e) => vm.onClickJoinGroupCall()}>
          {translate('Join')}
        </div>
      </div>} */}

    </div>
  )
}

export const renderComponent = (vm) => {
  return (<div>
    {vm.renderBody()}
    {(isElectron() && vm.stoppedCallObj?.rtcPeerConnection && vm.state.open_call_rating) &&
      <CallRatingComponent
        isOpen={true}
        group_id={vm.stoppedCallObj.group_id || 0}
        call_id={vm.stoppedCallObj.call_id || 0}
        score={0}
        func={(isOpen) => vm.openCallRating(isOpen)}
      />
    }
  </div>)
}